function youtubeAppPopup(popup_button_selector, popup_wrap_selector, template_selector, submit_button_selector, checkbox_selector, popup_close_selector ) {
  const popupButtonElem = document.querySelector(popup_button_selector);  
  if(popupButtonElem) {
    /* popupクリックイベント */
    popupButtonElem.addEventListener('click', function() {
      /* selecterからelem取得 */
      const popupWrapElem = document.querySelector(popup_wrap_selector);
      const templateElem = document.querySelector(template_selector);

      if(popupWrapElem && templateElem) {
        /* popup用のwrapperにtemplateを追加後 active */
        const ytptPopupFragment = templateElem.content.cloneNode(true);
        const insertedElements = Array.from(ytptPopupFragment.children);
        insertedElements.forEach(el => popupWrapElem.prepend(el));
        popupWrapElem.classList.add('active');

        /* popup内 submitボタン */
        const submitButtonElem = popupWrapElem.querySelector(submit_button_selector);
        
        /* popup内 checkボックスがある場合 */
        if (checkbox_selector) {
          const checkboxElem = popupWrapElem.querySelector(checkbox_selector);
          if (submitButtonElem && checkboxElem) {
            submitButtonElem.setAttribute('disabled', 'disabled');
            /* checkboxElemにチェックが入ったら.submitButtonElemのdisableを解除する */
            checkboxElem.addEventListener('change', function() {
              if (this.checked) {
                submitButtonElem.removeAttribute('disabled');
              } else {
                submitButtonElem.setAttribute('disabled', 'disabled');
              }
            });
          }
        }

        /* popup close */
        const popupCloseElem = popupWrapElem.querySelector(popup_close_selector);
        if(popupCloseElem) {
          popupCloseElem.addEventListener('click', function() {
            popupWrapElem.classList.remove('active');
            insertedElements.forEach(el => el.remove());
            if (submitButtonElem) {
              submitButtonElem.removeAttribute('disabled');
            }
          });
        }
      } 
    });
  }
}